"use-client"

import { observer } from "mobx-react-lite";
import { appState } from "@/app/appState";
import { PublicPageShell } from "@/components/PublicPageShell";

export const LegalPageFallback = observer(function LegalPageFallback({
    title,
}: {
    title: string;
}) {
    return (
        <PublicPageShell
            footerLanguageSwitcher
            contentClassName="justify-center items-center p-3"
        >
            <div className="public-card flex flex-col gap-3">
                <h1 className="h2">{title}</h1>
                <p className="serif">
                    {appState.t("marketing.legalFallback")}
                </p>
                <p>
                    <a href="mailto:kontakt@jaaw.dk" className="link">
                        kontakt@jaaw.dk
                    </a>
                </p>
            </div>
        </PublicPageShell>
    );
});
